module.exports = __webpack_public_path__ + "img/banner-4.19408e38.png";